import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import { getAlreadyDownloadedCVList } from "../../../../../redux/cv/action";
import { useAllFilterBaseContext } from "../../../../../Context/AllFilterBaseContext";
import { useDispatch, useSelector } from "react-redux";
import AllFilterPagination from "../../FilterAll/AllFilterPagination";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";
import { navigateToNextTab } from "../../../../Common/FewCommonMethods";
import Access from "../../../../CustomComponents/Access/Access";
import ImageWithFallback from "../../../../../common/ImageWithFallback";
import ProfileImageWithFallback from "../../../../../common/ProfileImageWithFallback";
import CommonPagination from "../../../../Common/PaginationComponet/CommonPagination";
const size = 9;

export default function DownloadCVListings({ }) {
  const dispatch = useDispatch();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const urexperttoken = localStorage.getItem("urexperttoken");
  const { state, setPageNumber } = useAllFilterBaseContext();
  const { pageNumber } = state;
  const getallcv = useSelector(({ cv: { getalreadydownloadedcvlist } }) => getalreadydownloadedcvlist);
  const expertslist = getallcv?.experts || [];
  const [modal, setModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");

  useEffect(() => {
    dispatch(getAlreadyDownloadedCVList({ index: pageNumber, size: size }));
  }, [pageNumber]);

  const applyandbitjob = (secitem) => {
    setSelectedItem(secitem);
    setModal(true);
  };

  const openDetails = (id) => {
    localStorage.setItem("prevCVPage", "SearchDownloadCV");
    navigateToNextTab(`cvdetails/${id}`)
  };


  return (
    <>
      {Array.isArray(expertslist) && expertslist.length > 0 ? (
        <>
          <div className="download-second">
            {Array.isArray(expertslist) &&
              expertslist?.map((item, index) => (
                <div className="filter-detail" key={index}>
                  <div className="filter-detail-first col-md-7">
                    <ProfileImageWithFallback url={item?.profile_image} className="profile-img" />
                    <div>

                      <>
                        <h5>
                          {item?.first_name} {item?.last_name}
                        </h5>
                        <h6>{item?.designation}</h6>
                      </>
                      <CustomReactQuillDescription value={item?.about} displyreadorless={false} />

                      <div className="proposal">
                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/location.svg`}
                            alt=""
                          />
                          {item?.working_country_title}
                        </p>
                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/year-box.svg`}
                            alt=""
                          />
                          {item?.experience} years
                        </p>
                        <p>
                          {" "}
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/dollar-1.svg`}
                          />
                          {item?.price_per_hour}/Hour - {item?.price_per_month}
                          /Month
                        </p>
                      </div>
                      <div className="photoshop">
                        {item?.skills &&
                          Array.isArray(item?.skills) &&
                          item?.skills.map((item1, index1) => (
                            <p key={index1}> {item1.title} </p>
                          ))}
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => {
                      urexperttoken
                        ? openDetails(item.id)
                        : applyandbitjob(item.id);
                    }}
                    className="buttons border-button"
                    fdprocessedid="pvvz"
                  >
                    View details
                  </button>
                </div>
              ))}
          </div>

          <CommonPagination totalitemcounts={getallcv?.count} size={size}
            pageNumber={state?.pageNumber}
            setPageNumber={setPageNumber}
          />
        </>
      ) : (
        <PostNotFound title={"Experts Not Found..."} />
      )}
      {modal ? (
        <Access
          modal={modal}
          setModal={setModal}
          pathurl={`/${lan}/cvdetails/${selectedItem}`}
          state={"state"}
          checkpermission={"apply_jobs"}
        />
      ) : (
        ""
      )}
    </>
  );
}
